import React from "react";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

interface ConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
  content: React.ReactNode;
  confirmButtonText?: string;
  cancelButtonText?: string;
  additionalMessage?: React.ReactNode;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onCancel,
  onConfirm,
  title,
  content,
  confirmButtonText = "Save All",
  cancelButtonText = "Cancel",
  additionalMessage,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      maskClosable={false}
      closable={false}
      width={620}
      styles={{
        content: {
          padding: 0,
          borderRadius: "24px",
        },
      }}
    >
      <div className="w-[620px] px-6 bg-white rounded-3xl shadow-[2px_4px_12px_0px_rgba(0,0,0,0.02)] outline-1 -outline-offset-1 outline-[rgba(0,0,0,0.05)] inline-flex flex-col justify-start items-center gap-6 overflow-hidden font-[Inter]">
        <div className="self-stretch pt-6 inline-flex justify-between items-center">
          <div className="justify-start text-[#0a0a0a] text-2xl font-semibold leading-8">
            {title}
          </div>
          <button
            onClick={onCancel}
            className="size-6 relative overflow-hidden flex items-center justify-center hover:opacity-70 transition-opacity cursor-pointer"
            aria-label="Close"
          >
            <CloseOutlined className="text-[rgba(0,0,0,0.4)]" />
          </button>
        </div>

        <div className="self-stretch flex flex-col justify-start items-start gap-3">
          {additionalMessage && (
            <div className="self-stretch justify-start text-[rgba(0,0,0,0.9)] text-sm font-normal leading-5">
              {additionalMessage}
            </div>
          )}

          <div className="self-stretch justify-start">
            {content}
          </div>
        </div>

        <div className="self-stretch pb-4 flex flex-col justify-start items-end gap-4">
          <div className="self-stretch h-0 outline-1 outline-offset-[-0.50px] outline-[rgba(0,0,0,0.05)]" />

          <div className="inline-flex justify-start items-center gap-4">
            <button
              onClick={onCancel}
              className="px-4 py-1.5 rounded-3xl flex justify-center items-center gap-2 hover:opacity-70 transition-opacity cursor-pointer"
            >
              <div className="justify-start text-[rgba(0,0,0,0.9)] text-base font-normal leading-6">
                {cancelButtonText}
              </div>
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-1.5 bg-[#0e49b5] rounded-3xl outline-1 -outline-offset-1 outline-transparent flex justify-center items-center gap-2 hover:opacity-90 transition-opacity cursor-pointer"
            >
              <div className="justify-start text-white text-base font-normal leading-6">
                {confirmButtonText}
              </div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;

